import { Action } from '@ngrx/store';

import { CurrentUserAndPermissions } from './current-user-and-permissions';

export enum CurrentUserActionTypes {
  REQUEST_CURRENT_USER = '[Current User] Request current user',
  STORE_CURRENT_USER = '[Current User] Store current user',
  STORE_ACCESS_TOKEN = '[Current User] Store access token',
  LOG_IN = '[Current User] log in via OAuth',
  LOG_OUT = '[Current User] log out',
}

export interface CurrentUserPayload {
  currentUser: CurrentUserAndPermissions;
}

export class RequestCurrentUserAction implements Action {
  readonly type = CurrentUserActionTypes.REQUEST_CURRENT_USER;
}

export class StoreCurrentUserAction implements Action {
  readonly type = CurrentUserActionTypes.STORE_CURRENT_USER;

  constructor(public payload: CurrentUserPayload) {}
}

export class StoreAccessTokenAction implements Action {
  readonly type = CurrentUserActionTypes.STORE_ACCESS_TOKEN;

  constructor(public payload: { accessToken: string }) {}
}

export class LogInAction implements Action {
  readonly type = CurrentUserActionTypes.LOG_IN;
}

export class LogOutAction implements Action {
  readonly type = CurrentUserActionTypes.LOG_OUT;
}

export type CurrentUserActions =
  | LogInAction
  | LogOutAction
  | RequestCurrentUserAction
  | StoreAccessTokenAction
  | StoreCurrentUserAction;
